import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './components/app';
import './components/carousel';
import './components/marquee.js';
import './external-links.js';
